/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Un `}<em parentName="p">{`CLI`}</em>{` o `}<em parentName="p">{`Command Line Interface`}</em>{` es una manera cómoda, fácil y rápida de inicializar un nuevo proyecto con las mejores prácticas utilizando un solo comando para configurar y comenzar a crear una aplicación increíble en unos segundos.`}</p>
    <p>{`Contienen toda la configuración necesaria para que puedas utilizar las últimas funciones de JavaScript y tengas una  gran experiencia de desarrollo gracias a que incluyen herramientas muy variadas como `}<em parentName="p">{`TypeScript`}</em>{`, `}<em parentName="p">{`ESLint`}</em>{`, `}<em parentName="p">{`PostCSS`}</em>{`, soporte para una `}<em parentName="p">{`PWA`}</em>{`, o lo necesario para implementar `}<em parentName="p">{`Unit Testing`}</em>{` o `}<em parentName="p">{`End-to-end Testing`}</em>{`.`}</p>
    <p>{`También suelen incluir un par de componentes y una landing page básica para que la tomes como referencia, los únicos requerimientos para utilizarlos son tener `}<inlineCode parentName="p">{`node`}</inlineCode>{` y `}<inlineCode parentName="p">{`npm`}</inlineCode>{` instalado en tu computadora.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;